import * as Sentry from "@sentry/vue";

/**
 * Safely sends a message to a Flutter channel with automatic error handling
 * @param channelName - The name of the Flutter channel (must be available on window)
 * @param message - The message to send (will be stringified if it's an object)
 * @param onError - Optional callback to execute if an error occurs
 */
export function sendMessageToFlutter(
  channelName: string,
  message?: string | object,
  onError?: (error: Error) => void,
): void {
  try {
    const channel = (window as any)[channelName];
    if (!channel || !channel.postMessage) {
      throw new Error(`Flutter channel '${channelName}' not available`);
    }

    if (message === undefined) {
      channel.postMessage({});
    } else if (typeof message === "string") {
      channel.postMessage(message);
    } else {
      channel.postMessage(JSON.stringify(message));
    }
  } catch (e) {
    Sentry.captureException(e);
    if (onError) {
      onError(e as Error);
    }
  }
}
